function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { getValue, getText } from './helpers.js';

var SingleSelect = /*#__PURE__*/function () {
  function SingleSelect(autocomplete) {
    _classCallCheck(this, SingleSelect);

    this.autocomplete = autocomplete;
    this.defaultValue = '';
    this.defaultText = '';
    this.autocomplete = autocomplete;
  }

  _createClass(SingleSelect, [{
    key: "connected",
    value: function connected() {
      // Store value and text attribute so that we can restore it when the parent form fires a `reset` event.
      this.defaultValue = this.hiddenField.value;
      this.defaultText = this.hiddenField.getAttribute('data-text') || '';
    }
  }, {
    key: "disconnected",
    value: function disconnected() {//
    }
  }, {
    key: "start",
    value: function start() {
      if (this.selectedOption) {
        this.autocomplete.combobox.select(this.selectedOption);
      }
    } // Reset input field.

  }, {
    key: "stop",
    value: function stop() {
      this.autocomplete.input.value = this.hiddenField.getAttribute('data-text') || '';
    }
  }, {
    key: "commit",
    value: function commit(option) {
      var value = getValue(option);
      var text = getText(option);
      this.setValue(value, text);
      this.autocomplete.open = false;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.setValue(null, null);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setValue(this.defaultValue, this.defaultText);
    }
  }, {
    key: "setValue",
    value: function setValue(value, text) {
      var _this = this;

      this.autocomplete.value = value || '';
      this.autocomplete.input.value = text || '';
      this.hiddenField.value = value || '';
      this.hiddenField.setAttribute('data-text', text || '');

      if (value === null) {
        this.autocomplete.combobox.deselectAll();
        return;
      } // Only select if the listbox is open because all options are deselected when it is hidden.


      if (this.autocomplete.open) {
        var option = this.autocomplete.options.find(function (option) {
          return getValue(option) === _this.defaultValue;
        });

        if (option) {
          this.autocomplete.combobox.select(option);
        }
      }
    } // Just to make the API similar to the multiple select.

  }, {
    key: "removeValue",
    value: function removeValue() {
      this.clear();
    }
  }, {
    key: "setRequiredAttribute",
    value: function setRequiredAttribute(value) {
      this.autocomplete.input.required = value;
    }
  }, {
    key: "firstActiveOption",
    get: function get() {
      return this.selectedOption || this.autocomplete.visibleOptions[0];
    }
  }, {
    key: "selectedOption",
    get: function get() {
      var _this2 = this;

      return this.autocomplete.options.find(function (option) {
        return _this2.isSelected(option);
      });
    }
  }, {
    key: "isSelected",
    value: function isSelected(option) {
      return getValue(option) === this.autocomplete.value;
    }
  }, {
    key: "hiddenField",
    get: function get() {
      return this.autocomplete.querySelector('[data-behavior="hidden-field"]');
    }
  }]);

  return SingleSelect;
}();

export { SingleSelect as default };